import React from "react";
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import { useMst } from "../../store/root";
import styles from "./Modal.module.scss";
import { ModalButton, TextButton } from "../baseComponents";
import { testBeforeRender } from "../../jsxProviders";
import { Checkbox } from "antd";

export const SceneHasData = observer(() => {
  const {
    uiStore: {
      sceneHasDataModalVisible,
      setSceneHasDataModalHidden,
      setDontAskAgainOverrideSceneData,
    },
    compositionStore: { selectedCompositionsName, fillQueuedCompositions },
    projectStore: { selectedSceneExists },
  } = useMst();
  return (
    <Modal
      className={styles.Modal}
      visible={sceneHasDataModalVisible}
      onOk={() => setSceneHasDataModalHidden}
      onCancel={setSceneHasDataModalHidden}
      footer={false}
    >
      <h1>Notice!</h1>
      <p className={styles.Speech}>
        uploading the composition will override existing data, would you like to
        proceed? Concerning scenes:
      </p>
      {selectedCompositionsName
        .filter((comp) => selectedSceneExists(comp)?.jsonUrl)
        .map((compWithData) => (
          <p key={compWithData}>{compWithData}</p>
        ))}
      <div className={styles.Buttons}>
        <TextButton onClick={setSceneHasDataModalHidden} text="No" />
        <ModalButton
          onClick={() => {
            fillQueuedCompositions();
            testBeforeRender();
            setSceneHasDataModalHidden();
          }}
          text="Yes"
        />
      </div>
      <Checkbox
        onChange={(e) => setDontAskAgainOverrideSceneData(e.target.checked)}
      >
        Don’t ask me again
      </Checkbox>
    </Modal>
  );
});
